import React from 'react';
import { Line } from 'react-chartjs-2';
import Chart from 'chart.js/auto';

const LineGraph = ({
    labels, data, label, yAxisLabel,
}) => {
    const lineData = {
        labels,
        datasets: [
            {
                label,
                data,
                fill: false,
                borderColor: 'rgba(128, 38, 41, 1)',
            },
        ],
    };

    const options = {
        scales: {
            x: {
                type: 'category',
                display: true,
                scaleLabel: {
                    display: true,
                    labelString: 'Year and Month', // Customize the X-axis label as needed
                },
                ticks: {
                    autoSkip: true,
                    maxTicksLimit: 20, // Adjust the number of ticks as needed
                },
            },
            y: {
                display: true,
                scaleLabel: {
                    display: true,
                    labelString: yAxisLabel, // Customize the Y-axis label
                },
                ticks: {
                    autoSkip: true,
                    maxTicksLimit: 10, // Adjust the number of ticks as needed
                },
            },
        },
    };

    return (
        <div>
            <h2>Line Graph</h2>
            <Line data={lineData} options={options} />
        </div>
    );
};

export default LineGraph;
